<template>
  <div>
    <!-- 菜单 -->
    <div id="contextmenu" v-show="menuVisible" class="menu">
      <div class="contextmenu__item" @click="MainMenuHandleCommand('setpass')">
        <i class="el-icon-key menu_item_icon"></i>修改密码
      </div>
      <div class="contextmenu__item" @click="MainMenuHandleCommand('about')">
        <i class="el-icon-info menu_item_icon"></i>关于...
      </div>
      <div class="contextmenu__item" @click="MainMenuHandleCommand('logout')">
        <i class="el-icon-circle-close menu_item_icon"></i>退出系统
      </div>
    </div>
    <!-- 顶部导航栏 -->
    <div class="header d-flex ai-center jc-between">
      <span class="d-flex ai-center">
        <img class="m-1" src="@/assets/logo.png" alt="" width="45" />
        <span class="ml-2">
          <div>{{ systemName }}</div>
        </span>
      </span>
      <span :style="userInfoStyle" class="d-flex ai-center jc-end title">
        <!-- <span class="mr-1 fs-xl">你好，{{user.name}}</span> -->
        <span class="menuIco mr-1" @click="menuIconClick" @click.stop="menuVisible == true">
          <!--  shape="square" -->
          <el-avatar>
            <b>
              {{
                user.name === ""
                  ? "登录"
                  : user.name.length == 2
                    ? user.name
                    : user.name.substr(1)
              }}
            </b>
          </el-avatar>
        </span>
      </span>
    </div>
    <div class="main" type="flex" justify="center">
      <router-view />
    </div>

    <mt-tabbar v-model="selected">
      <mt-tab-item id="list" @click.native="selectTab()" v-if="user.hasRoles.isAdmin || user.hasRoles.isSuper">
        <img slot="icon" src="@/assets/finish.png" />
        网络留言
      </mt-tab-item>
      <mt-tab-item id="unitlist" @click.native="selectTab()" v-if="
        user.hasRoles.isManager &&
        !user.hasRoles.isAdmin &&
        !user.hasRoles.isSuper
      ">
        <img slot="icon" src="@/assets/finish.png" />
        工单办理
      </mt-tab-item>
      <mt-tab-item id="new" @click.native="selectTab()" v-if="user.hasRoles.isAdmin || user.hasRoles.isSuper">
        <img slot="icon" src="@/assets/star2.png" />
        负面舆情
      </mt-tab-item>
      <mt-tab-item id="my" @click.native="selectTab()">
        <img slot="icon" src="@/assets/wo.png" />
        我的
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
export default {
  beforeRouteLeave(to, from, next) {
    // 在离开前执行一些操作，例如提示用户保存数据
    // ...

    // 执行next()，表示继续进行路由切换
    next();
  },
  async created() {
    var res = await this.pstApi.getWebsiteParameters();
    if (!(res.status && res.status == 200)) {
      console.log("网站参数读取失败");
      return "";
    } else {
      //系统参数获取成功后设置系统参数
      var parameters = res.data;
      this.pstApi.setWebsiteParameters(parameters);
    }
    // 设置网页标题
    window.document.title = this.SystemTitle;

    this.systemName = this.SystemName;
    var userInfo = this.appApi.getUserData();
    // console.log("用户信息:", userInfo);
    //window.sessionStorage.getItem("userInfo");
    if (userInfo) {
      this.user = userInfo; //JSON.parse(userInfo);
      if (this.user.passwordVerifyPass == false) {
        console.log("false");
        //this.MainMenuHandleCommand("logout");
      }
    } else {
      //返回登录界面
      //this.MainMenuHandleCommand("logout");
    }

    //store存储与恢复
    // 在页面加载时读取sessionStorage里的状态信息
    if (window.sessionStorage.getItem("store") != null) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(window.sessionStorage.getItem("store"))
        )
      );
      //提取菜单id
      var actionId = this.$store.state.actionMenu;
      if (actionId != null) {
        this.selected = actionId;
      }
    }

    var path = this.$route.path;
    if (path == "/PstQuery") {
      this.selected = "list";
    } else if (path == "/HandleQuery") {
      this.selected = "unitlist";
    } else {
      this.selected = "my";
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    //beforeunload事件在页面刷新时先触发
    window.addEventListener("beforeunload", () => {
      window.sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });

    this.appApi.setWindowTitle();
  },
  destroyed() {
    // EventHome.$off("headerEvent");
  },
  mounted() { },
  data() {
    return {
      selected: "my",
      // 菜单
      menuVisible: false,
      userInfoStyle: {
        whiteSpace: "nowrap",
        width: "50PX",
      },
      user: "",
      systemName: "",
    };
  },
  methods: {
    // 菜单公用方法
    menuIconClick(event) {
      this.menuVisible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
      this.menuVisible = true; // 显示模态窗口，跳出自定义菜单栏
      event.preventDefault(); //关闭浏览器右键默认事件
      var menu = document.querySelector(".menu");

      this.styleMenu(menu);
    },
    foo() {
      // 取消鼠标监听事件 菜单栏
      this.menuVisible = false;
      document.removeEventListener("click", this.foo); // 关掉监听
    },
    styleMenu(menu) {
      var avatar = document.querySelector(".menuIco");
      var posLeft = avatar.getBoundingClientRect().right;
      var posTop = avatar.getBoundingClientRect().bottom;
      // console.log(posLeft,posTop);
      document.addEventListener("click", this.foo); // 给整个document新增监听鼠标事件，点击任何位置执行foo方法
      var clientWidth = document.documentElement.clientWidth;
      posLeft = clientWidth - posLeft > 130 ? posLeft - 50 : clientWidth - 140;
      menu.style.left = posLeft + "px";
      menu.style.top = posTop + "px";
    },

    //框架主下拉菜单命令
    MainMenuHandleCommand(command) {
      if (command == "setpass") {
        this.selected = "my";
        this.$store.commit("setActionId", this.selected);
        this.$router.push({ name: "Password" });
      }
      if (command == "about") {
        this.selected = "my";
        this.$store.commit("setActionId", this.selected);
        this.$router.push({ name: "About" });
      }
      if (command == "logout") {
        //清除服务器token缓存
        this.userApi
          .logout()
          .then(() => {
            this.$toast("登出成功");
            console.log("logout");
            // window.sessionStorage.setItem("store",'');
            window.sessionStorage.removeItem("userInfo");
            window.sessionStorage.clear();
            this.$router.push({ name: "Home" });
          })
          .catch(() => {
            console.log("err");
          });
      }
    },
    selectTab() {
      this.$store.commit("setActionId", this.selected);
      switch (this.selected) {
        case "list":
          this.$router.push({ name: "PstQuery" });
          break;
        case "unitlist":
          this.$router.push({ name: "HandleQuery" });
          break;
        case "new":
          this.$router.push({ name: "Negatives" });
          break;
        case "my":
          this.$router.push({ name: "My" });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.navigation {
  width: 100%;
  height: 60px;
  background-color: #333744;
}

.welcometext {
  margin-right: 10px;
  font-size: 14px;
  color: #9e9b9b;
}

.title {
  width: 100%;
  height: 50px;
  color: red;
  // line-height: 30px;
}

.main {
  width: 100%;
}

// 菜单样式
.contextmenu__item {
  padding-left: 15px;
  display: block;
  line-height: 34px;
  text-align: left;
}

.contextmenu__item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.menu_item_icon {
  margin-right: 5px;
  width: 20px;
  height: 20px;
}

.menu {
  position: absolute;
  background-color: #fff;
  width: 120px;
  /*height: 106px;*/
  font-size: 14px;
  color: #444040;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 1000;
}

.menuIco {
  cursor: pointer;
}

.contextmenu__item:hover {
  cursor: pointer;
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.badge {
  position: absolute;
  top: 5px;
  left: 2px;
}

.el-avatar {
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  color: rgb(252, 0, 0);
  background: #f3e594;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}
</style>